import { render, staticRenderFns } from "./ClassTypes.vue?vue&type=template&id=31af0ae5"
import script from "./ClassTypes.vue?vue&type=script&lang=js"
export * from "./ClassTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports